// extracted by mini-css-extract-plugin
export default {"changeLink":"jP-z","disabled":"kP-z","inline":"lP-z"};